{
  "appTitle": "BACK OFFICE",
  "greetings": [
    "Hallo! Schön, dich wiederzusehen!",
    "Willkommen zurück! Bereit loszulegen?",
    "Gut, dich wiederzuhaben!",
    "Hallo! Lass uns an die Arbeit gehen.",
    "Wieder da? Los geht's!",
    "Schön, dich zu sehen. Lass uns starten."
  ],
  "email": "E-Mail",
  "continue": "Weiter",
  "password": "Passwort",
  "sign-in": "Anmelden",
  "back": "Andere E-Mail verwenden",
  "sso-redirecting": "Weiterleitung zur SSO...",
  "or": "oder",
  "passkey": {
    "signIn": "Mit Passkey anmelden",
    "error": "Passkey-Anmeldung fehlgeschlagen. Bitte erneut versuchen oder Passwort verwenden.",
    "unknownCredential": "Dieser Passkey wird nicht erkannt. Bitte melde dich mit deinem Passwort an."
  },
  "mfa": {
    "label": "Authentifizierungscode",
    "hint": "Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App ein.",
    "verify": "Bestätigen",
    "invalidCode": "Falscher Code – bitte erneut versuchen."
  },
  "changePassword": {
    "description": "Ihr Passwort muss aktualisiert werden, bevor Sie fortfahren können.",
    "current": "Aktuelles Passwort",
    "new": "Neues Passwort",
    "confirm": "Neues Passwort bestätigen",
    "submit": "Passwort aktualisieren",
    "mismatch": "Die neuen Passwörter stimmen nicht überein.",
    "wrongCurrent": "Das aktuelle Passwort ist falsch.",
    "error": "Passwort konnte nicht aktualisiert werden. Bitte erneut versuchen."
  },
  "errors": {
    "invalidCredentials": "Anmeldung nicht möglich, bitte Zugangsdaten prüfen und erneut versuchen",
    "unauthorized": "Anmeldung nicht möglich, bitte erneut versuchen",
    "accountLocked": "Konto ist gesperrt, bitte später erneut versuchen",
    "accessNotGranted": "Kein Zugriff auf das Back Office gewährt",
    "ssoRequired": "Dieses Konto verwendet Single Sign-On. Bitte melde dich über SSO an."
  }
}
